import {
  ApiOutlined,
  CheckCircleFilled,
  EditOutlined,
  EllipsisOutlined,
  ExclamationCircleFilled,
  SettingOutlined,
  InfoCircleOutlined,
  QuestionCircleFilled,
  DisconnectOutlined,
} from "@ant-design/icons";
import { Card, Col, Flex, Row, Tag, Tooltip, Typography } from "antd";

const { Text, Title } = Typography;

const gridStyle = {
  width: "50%",
  textAlign: "center",
};

const cardTitle = (props) => {
  const { device, themeToken } = props;

  return (
    <div>
      <Flex justify="space-between" align="center">
        <div>
          {!device.isConnected ? (
            <ApiOutlined />
          ) : ["danger", "Danger"].includes(device.status) ? (
            <ExclamationCircleFilled style={{ color: themeToken.colorError }} />
          ) : ["warning", "Warning"].includes(device.status) ? (
            <ExclamationCircleFilled
              style={{ color: themeToken.colorWarning }}
            />
          ) : ["good", "Good", "Online"].includes(device.status) ? (
            <CheckCircleFilled style={{ color: themeToken.colorSuccess }} />
          ) : ["Offline", "OFFLINE"].includes(device.status) ? (
            <DisconnectOutlined />
          ) : (
            <QuestionCircleFilled style={{ color: themeToken.colorPrimary }} />
          )}
        </div>
        <Title level={5} className="m-0" ellipsis>
          {device.name}
        </Title>
        <div></div>
      </Flex>
    </div>
  );
};

function DeviceCard({ device, themeToken, setOpenModal }) {
  const numberFormat = { maximumFractionDigits: 2, minimumFractionDigits: 2 };

  return (
    <Card
      bordered
      title={cardTitle({ device, themeToken })}
      className={
        device.status == "danger"
          ? "device-card-danger"
          : device.status == "warning"
          ? "device-card-warning"
          : ""
      }
      extra={<EllipsisOutlined onClick={() => setOpenModal(true)} />}
      style={{ borderRadius: 8, opacity: device.isConnected ? 1 : 0.7 }}
    >
      {device?.properties?.map((p, index) => {
        return [
          <Card.Grid
            key={`${device.ID}-${p.name}`}
            hoverable={false}
            style={{ width: "50%", paddingBlock: 12, paddingInline: 18 }}
          >
            <Text>{p.name}</Text>
          </Card.Grid>,
          <Card.Grid
            key={`${device.ID}-${p.name}-value`}
            hoverable={false}
            style={{ width: "50%", paddingBlock: 12, paddingInline: 18 }}
          >
            <Flex justify="space-between" align="center">
              <div>
                <Text strong={true}>
                  {p.value.toLocaleString("en-US", numberFormat) + " "}
                </Text>
                <Text>{p.unit?.toString()}</Text>
              </div>
              <div>
                <Tooltip
                  title={
                    p.value === "-"
                      ? "There is an issue with data quality. The value is last updated at " +
                        p.valueDateTime
                      : p.valueDateTime !== ""
                      ? "Last update: " + p.valueDateTime
                      : ""
                  }
                >
                  <InfoCircleOutlined
                    style={{
                      display: p.value !== "N/A" ? "block" : "none",
                    }}
                  />
                </Tooltip>
              </div>
            </Flex>
          </Card.Grid>,
        ];
      })}
      <Flex
        justify="start"
        align="center"
        className="p-3"
        style={{ width: "100%" }}
      >
        <Tag
          color="#536493"
          style={{
            maxWidth: `calc(100% / ${
              1 +
              (device?.area != "N/A" ? 1 : 0) +
              (device?.seu != "N/A" ? 1 : 0)
            })`,
          }}
        >
          <Text
            ellipsis={{
              tooltip: device?.deviceType,
            }}
            style={{ color: "white", width: "100%" }}
          >
            {device?.deviceType}
          </Text>
        </Tag>
        {device?.area !== "N/A" ? (
          <Tag
            color={themeToken.purple6}
            style={{
              maxWidth: `calc(100% / ${2 + (device?.seu != "N/A" ? 1 : 0)})`,
            }}
          >
            <Text
              ellipsis={{
                tooltip: device?.area,
              }}
              style={{
                color: "white",
                width: "100%",
              }}
            >
              {device?.area}
            </Text>
          </Tag>
        ) : (
          <div style={{ height: "24px" }} />
        )}
        {device?.seu !== "N/A" ? (
          <Tag
            color={themeToken.cyan6}
            style={{
              maxWidth: `calc(100% / ${2 + (device?.seu != "N/A" ? 1 : 0)})`,
            }}
          >
            <Text
              ellipsis={{
                tooltip: device?.seu,
              }}
              style={{ color: "white", width: "100%" }}
            >
              {device?.seu}
            </Text>
          </Tag>
        ) : (
          <div style={{ height: "24px" }} />
        )}
      </Flex>
    </Card>
  );
}

export default DeviceCard;
